import { useContext, useEffect, useState, useRef, useLayoutEffect } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Registro from "@ComponentesCuerpo/Registro/Registro";
import "./Tabla.css";

function Tabla(props) {
  const { esComputadora } = useContext(Contexto);
  const { estilos, elementos } = props.param;
  const [estilosTabla, setEstilosTabla] = useState(estilos)
  const [estilosCabecera, setEstilosCabecera] = useState({})
  const [estilosRegistro, setEstilosRegistro] = useState({})
  const [elementosRegistroCabecera, setElementosRegistroCabecera] = useState([])
  const [elementosRegistroRegistro, setElementosRegistroRegistro] = useState([])
  

  useEffect(() => {
    
  },[])

  useEffect(() => {
    const estructuraCabecera = estilos.cabecera;
    const estructuraRegistro = estilos.registros;
    const elementosCabecera = elementos.cabecera;
    const elementosRegistro = elementos.registros;
    let total = 0
    const columnas = estructuraCabecera.map(e => (isNaN(parseFloat(e.estilos.ancho)) ? 0 : parseFloat(e.estilos.ancho)));
    const registroCabecera = elementosCabecera.map((e) => {
      const estElemCabecera = estructuraCabecera.find(ec => ec.name === e.name);
      return {
        texto: e.texto,
        tipo: estElemCabecera?.tipo,
        name: `${e.name}`,
        estilos: estElemCabecera?.estilos
      };
    });
    setElementosRegistroCabecera(registroCabecera)
    columnas.forEach(e => {
      total = total + e;
    })
    let registrosElementos = []
    elementosRegistro.forEach(elr => {
      let registro = []
      estructuraCabecera.forEach(ec => {
        const estElemRegistro = estructuraRegistro.find(er => er.name === ec.name);
        registro.push({
          texto: elr[ec.name],
          tipo: estElemRegistro?.tipo,
          name: `${ec.name}${elr.id}`,
          estilos: estElemRegistro?.estilos
        });
      });
      registrosElementos.push(registro)
    });
    setElementosRegistroRegistro(registrosElementos)
    setEstilosCabecera ({columnas: columnas.map(e => (e/total*100+"%")).join(" ")});
    setEstilosRegistro ({columnas: columnas.map(e => (e/total*100+"%")).join(" ")});
    setEstilosTabla({...estilosTabla,
      anchoTotal: total+"%"
    })
  }, [estilos, elementos]);

  return (
    <>
    <div className="Tabla" style={_f_.estilosObjetoVariablesCSS(estilosTabla)} >
      <div className="CabeceraTabla">
        <Registro param={{estilos: estilosCabecera, elementos: elementosRegistroCabecera}}/>
      </div>
      <div className="Registros">
        {elementosRegistroRegistro.map((e) => {
          return (
          <Registro param={{estilos:estilosRegistro, elementos:e}}/>)
        })}
        
      </div>
    </div>  
    </>
  )
}
export default Tabla;